import { useQuery } from "@tanstack/react-query";
import {
  reportTemplatesApi,
  type ReportItemPrefillDto,
} from "@/api/reportTemplates";

/**
 * Deal work-tab "Generate report" deep link. Resolves the item's catalog code
 * (criteria item like "F-DK1" or Section-2 certification like
 * "Fin.S2.DscrComputed") to its seeded report template plus the pre-drafted
 * intake. `data` is null when no match exists for the caller's role — the
 * button must be hidden, never rendered dead. Errors (e.g. the caller lacks
 * Reports.Generate) behave the same: no data, no button.
 */
export function useReportItemPrefill(
  itemCode: string | null | undefined,
  dealId: string | null | undefined,
  enabled = true,
) {
  return useQuery<ReportItemPrefillDto | null>({
    queryKey: ["report-item-prefill", itemCode, dealId],
    queryFn: () => reportTemplatesApi.itemPrefill(itemCode!, dealId!),
    enabled: enabled && !!itemCode && !!dealId,
    // Seed-managed mapping + deal vitals; cheap to cache per modal session.
    staleTime: 5 * 60 * 1000,
    retry: false,
  });
}

/** The generator deep link the "Generate report" button opens in a new tab. */
export function reportGenerateDeepLink(
  templateId: string,
  dealId: string,
  itemCode: string,
): string {
  const params = new URLSearchParams({ templateId, dealId, itemCode });
  return `/reports/generate?${params.toString()}`;
}
